<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-body>
        <div class="flex-centered col-xl-4 col-lg-6 col-md-8 col-sm-12">
          <h2 class="title">404 Page Not Found</h2>
          <small class="sub-title">The page you were looking for doesn't exist</small>
          <button nbButton fullWidth (click)="goToHome()" type="button" class="home-button btn-circle btn-xl">
            Take me home
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
